export enum ComponentRequisitionStatusEnum {
    Created = 'Created',
    Approved = 'Approved',
    Rejected = 'Rejected',
}
